export enum iOSPermissions {
  CAMERA = 'camera',
  LOCATION = 'location',
  BLUETOOTH_CONNECT = '',
  BLUETOOTH_SCAN = '',
}
